export interface PaginationResponse<T> {
  docs: T[];
  limit: number;
  offset: number;
  page: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  count: number;
  pageCount: number;
}

export enum PostType {
  STORY = 'STORY',
  POST = 'POST',
}

export enum PostOrigin {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  WHATSAPP = 'WHATSAPP',
}

export interface RecentPost {
  _id: string;
  type: PostType | string;
  origin: PostOrigin | string;
  externalId: string;
  message?: string;
  templateId?: string;
  thumbnailUrl?: string;
  user?: {
    firstName: string;
    lastName: string;
    displayName?: string;
  };
  createdAt: string;
  template?: {
    name?: string;
    thumbnailUrl?: string;
    thumbnailPath?: string;
  };
  mentionedEntities?: {
    type: string;
    id: string;
    name?: string;
    thumbnailUrl?: string | null;
  }[];
}

export interface PlannedPostOptions {
  instagramPost: boolean;
  facebookPost: boolean;
  instagramStory: boolean;
  facebookStory: boolean;
  whatsappPost?: boolean;
}

export interface PlannedPost {
  _id: string;
  scheduledFor: string;
  status: 'SCHEDULED' | 'FAILED';
  originalFile: string;
  thumbnailPath?: string;
  thumbnailUrl?: string;
  user?: {
    firstName: string;
    lastName: string;
    displayName?: string;
  };
  error?: any;
  createdAt: string;
  updatedAt: string;
  message?: string;
  templateId?: string;
  template?: {
    thumbnailUrl?: string;
  };
  pageId: string;
  options: PlannedPostOptions;
  whatsappGroupIds?: string[];
  mentionedEntities: {
    type: string;
    id: string;
    name?: string;
    thumbnailUrl?: string | null;
  }[];
}

export interface MostUsedTemplate {
  templateId: string;
  name: string;
  thumbnailUrl?: string;
  importedFromTemplateId?: string;
  count: number;
}

export interface GenerateCaptionEntityContextDto {
  slotKey: string;
  entityType: string;
  label?: string;
  data: Record<string, any>;
}

export interface GenerateCaptionTextElementDto {
  name: string;
  value: string;
}

export interface GenerateCaptionRequestDto {
  mode?: 'GENERATE' | 'IMPROVE';
  draftSessionId: string;
  templateId?: string;
  templateName: string;
  aspectRatio?: string;
  format?: string;
  selectedPlatforms: string[];
  entities: GenerateCaptionEntityContextDto[];
  textElements: GenerateCaptionTextElementDto[];
  autoTriggered?: boolean;
  isCustomUpload?: boolean;
  sourceCaption?: string;
}

export interface GenerateCaptionResponseDto {
  caption: string;
  stylePreset: string;
  provider: string;
  model: string;
  totalTokens: number;
  inputTokens: number;
  outputTokens: number;
  reasoningTokens: number;
  generationCount: number;
  remainingRegenerations: number;
  improvementCount: number;
  remainingImprovements: number;
}
